"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Bar = void 0;

var tslib_1 = require("tslib");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_symbols_1 = require("@hopin-team/ui-symbols");

var styled_components_1 = tslib_1.__importDefault(require("styled-components"));

var root_1 = require("./root");

exports.Bar = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  background-color: ", ";\n  // If more sizes are added, make sure to also update below\n  border-radius: ", "\n  }\n  height: 100%;\n  width: ", ";\n  transition-property: width;\n  transition-duration: ", ";\n  transition-timing-function: ", ";\n"], ["\n  background-color: ", ";\n  // If more sizes are added, make sure to also update below\n  border-radius: ", "\n  }\n  height: 100%;\n  width: ", ";\n  transition-property: width;\n  transition-duration: ", ";\n  transition-timing-function: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.UTILITY.ACTION', theme);
}, function (_a) {
  var layout = _a.layout,
      progress = _a.progress;
  var bR = (0, ui_symbols_1.calcSpace)(root_1.Sizes.medium / 2);
  if (layout === root_1.Layout.item) return "".concat(bR); // default rounded corners for layout="item"

  if (progress === 100) return 0; // no rounded corners for layout="page" when progress is 100%

  return "0 ".concat(bR, " ").concat(bR, " 0;"); // rounded right side corners for layout="page" when progress is < 100%
}, function (_a) {
  var progress = _a.progress;
  return "".concat(progress, "%");
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('MOTION.BASE_DURATION', theme);
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('MOTION.BASE_TIMING', theme);
});
var templateObject_1;